const normalizeInitialOrderBys = (value, columns) => {
  if (value && Object.keys(value).length > 0) {
    return value;
  }
  return Object.fromEntries(Array.from(columns.entries()).flatMap(([i, value2]) => {
    if (value2.enableOrdering !== false && value2.initialOrder) {
      return [[i, value2.initialOrder]];
    }
    return [];
  }));
};
export {
  normalizeInitialOrderBys
};
//# sourceMappingURL=normalizeInitialOrderBys.js.map
